export const SEGMENT_OPTIONS = [
  ['none', 'No breakdown'],
  ['language', 'By call language'],
  ['project', 'By platform project'],
];
export const SEGMENT_LABEL = Object.fromEntries(SEGMENT_OPTIONS);

export const normalizeId = (id) =>
  String(id ?? '')
    .trim()
    .toLowerCase();

export const isOrganizationId = (id) => /^[0-9a-f]{24}$/.test(normalizeId(id));

export function toPlatformOrgItems(rows) {
  const items = rows
    .map((r) => ({
      organizationId: normalizeId(r.organizationId),
      label: String(r.label ?? '').trim(),
      segmentBy: r.segmentBy || 'none',
    }))
    .filter((r) => r.organizationId || r.label);
  if (items.some((r) => !r.organizationId))
    return { error: 'Every row needs an organization id.' };
  return { items };
}

export function fillLabelFromPlatform(rows, id, name) {
  if (!Array.isArray(rows) || !name) return rows;
  return rows.map((row) =>
    normalizeId(row.organizationId) === id && !String(row.label ?? '').trim()
      ? { ...row, label: name }
      : row,
  );
}
